import * as React from 'react';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const PlaceholderIndicator = styled.div.withConfig({
  displayName: "PlaceholderContent__PlaceholderIndicator",
  componentId: "kynkc4-0"
})(["width:", "px;height:100%;border:", " dashed ", ";border-radius:", ";position:relative;transition:all 0.2s ease;&:hover{background:", ";}"], props => props.size, ({
  theme
}) => theme.borderWidth['200'], ({
  theme
}) => theme.color['border-interactive-default'], ({
  theme
}) => theme.borderRadius['100'], ({
  theme
}) => theme.color['fill-surface-default-hover']);
export function PlaceholderContent({
  size,
  targetIndex,
  as: Element = 'th',
  dataTestId,
  dropRef
}) {
  return /*#__PURE__*/_jsx(Element, {
    ref: dropRef,
    "data-test-id": dataTestId || `placeholder-${targetIndex}`,
    children: /*#__PURE__*/_jsx(PlaceholderIndicator, {
      size: size
    })
  });
}